var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26,
    height: 26,
    viewBox: "0 0 129 102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-logo-192"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 129,
    height: 102
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-192",
    clipPath: "url(#clip-logo-192)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_210",
    "data-name": "Group 210",
    transform: "translate(-12244.038 -14164)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M-593.319,117.433h-71.61a5.719,5.719,0,0,0-5.719,5.714,5.726,5.726,0,0,0,5.719,5.741h71.61a5.756,5.756,0,0,0,5.754-5.741,5.749,5.749,0,0,0-5.754-5.714",
    transform: "translate(12936.715 14135.152)",
    fill: "#1c3444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M-563.175,155.921h-104.2V95.9h104.2Zm5.719-71.449H-673.11a5.727,5.727,0,0,0-5.735,5.722v71.433a5.725,5.725,0,0,0,5.735,5.708h115.654a5.725,5.725,0,0,0,5.738-5.708V90.194a5.728,5.728,0,0,0-5.738-5.722",
    transform: "translate(12922.883 14079.528)",
    fill: "#1c3444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M-665.656,120.555V102.414a1.323,1.323,0,0,1,1.32-1.309h7.531a1.323,1.323,0,0,1,1.319,1.309v18.141a1.321,1.321,0,0,1-1.319,1.317h-7.531a1.314,1.314,0,0,1-1.32-1.317",
    transform: "translate(12945.14 14107.598)",
    fill: "#1c3444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M-649.362,135.925V93.3A1.31,1.31,0,0,1-648.04,92h7.528a1.306,1.306,0,0,1,1.311,1.3v42.627a1.32,1.32,0,0,1-1.311,1.317h-7.528a1.317,1.317,0,0,1-1.322-1.317",
    transform: "translate(12972.637 14092.228)",
    fill: "#1c3444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M-646.142,97.97h-7.539a1.325,1.325,0,0,0-1.312,1.317v26.559a1.32,1.32,0,0,0,1.312,1.317h7.539a1.316,1.316,0,0,0,1.32-1.317V99.287a1.321,1.321,0,0,0-1.32-1.317",
    transform: "translate(12963.136 14102.307)",
    fill: "#1c3444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M-651.475,94.467h-7.536a1.307,1.307,0,0,0-1.306,1.317v35.989a1.3,1.3,0,0,0,1.306,1.3h7.536a1.311,1.311,0,0,0,1.32-1.3V95.784a1.309,1.309,0,0,0-1.32-1.317",
    transform: "translate(12954.149 14096.396)",
    fill: "#1c3444"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/default.4c7c82844a210ffb2d5da4768a3f47a7.svg";
export { ForwardRef as ReactComponent };